import { render } from "./RightPanel_v2.vue?vue&type=template&id=56b15f24&scoped=true&ts=true"
import script from "./RightPanel_v2.vue?vue&type=script&lang=ts"
export * from "./RightPanel_v2.vue?vue&type=script&lang=ts"

import "./RightPanel_v2.vue?vue&type=style&index=0&id=56b15f24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b15f24"]])

export default __exports__